import { useContext, useEffect } from "react";
import Slider from "react-slick";
import { AppContext } from "../App";
import p1 from "../assets/Terrazzo/banner1.jpeg";
import p2 from "../assets/LGS/banner1.jpeg";
import p3 from "../assets/Waterproofing/banner1.jpeg";
import p4 from "../assets/Terrazzo/banner2.jpg";
import p5 from "../assets/LGS/banner2.jpg";
import p6 from "../assets/Waterproofing/banner2.jpg";
import p7 from "../assets/Terrazzo/banner8.jpg";
import p8 from "../assets/LGS/banner3.jpg";
import p9 from "../assets/Waterproofing/banner3.jpg";
import p10 from "../assets/Terrazzo/banner4.jpg";
import p11 from "../assets/LGS/banner4.jpeg";
import p12 from "../assets/Waterproofing/banner4.jpg";
import banner7 from "../assets/Terrazzo/banner7.jpg";
import banner1 from "../assets/banner7.jpg";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  MdOutlineArchitecture,
  MdOutlineGridView,
  MdOutlineWaterDrop,
  MdCheckCircleOutline,
} from "react-icons/md";

export default function HomeBanner0() {

  useEffect(() => {
    AOS.init({
      duration: 1000,   // animation duration
      once: false       // animation runs once
    });
  }, []);


  const appContext = useContext(AppContext);

  const productCards = [
    {
      subItem: "light-gauge-steel",
      title: "Light Gauge Steel",
      applications:
        "Wall frames, roof trusses, roof purlins, floor joists, modular construction and both vertical and horizontal extensions.",
      message:
        "We supply precision-engineered Light Gauge Steel systems that accelerate construction, reduce structural weight and ensure predictable performance while minimizing material waste.",
      image: p1,
      icon: <MdOutlineGridView size={20} />,
      featured: true,
    },
    {
      subItem: "waterproofing-solutions",
      title: "Waterproofing Solutions",
      applications:
        "Foundations, roofs, walls, bathrooms and water-retaining structures for both new construction and upgrades.",
      message:
        "We supply waterproofing systems that prevent leaks and moisture intrusion, reducing maintenance costs and supporting long-term building resilience.",
      image: p2,
      icon: <MdOutlineWaterDrop size={20} />,
    },
    {
      subItem: "terrazzo-flooring",
      title: "Terrazzo Flooring",
      applications:
        "Seamless high-strength flooring for institutions, hospitals, schools, commercial spaces and high-traffic environments.",
      message:
        "We supply terrazzo flooring systems built to withstand decades of heavy use, delivering cost-effective, long-term reliability for demanding projects.",
      image: p3,
      icon: <MdOutlineArchitecture size={20} />,
    },
  ];

  const heroPoints = [
    "Eliminating delays, water damage and weak flooring",
    "Faster builds with precision-engineered steel",
    "Lasting protection through advanced waterproofing",
    "Seamless durability with terrazzo flooring",
    "Dependable logistics and predictable workflows",
    "Sustainable solutions that minimize waste",
  ];

  const heroSliderImages = [banner1, p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11, p12];

  const heroSliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 650,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2800,
    pauseOnHover: true,
  };

  return (
    <section className="MainBodySection home-hero-product">
      <div className="px-2">
        <div className="home-hero-grid">
          <article
            className="home-hero-main-card h-100"
            data-aos="fade-right"
            data-aos-duration="1100"
            data-aos-offset="120"
          >
            <div className="home-hero-main-overlay" />
            <div className="home-hero-main-content">
              <div className="home-hero-main-media rounded mb-1">
                <Slider {...heroSliderSettings}>
                  {heroSliderImages.map((image, index) => (
                    <div key={`hero-slide-${index}`}>
                      <div className="home-hero-main-slide" style={{ backgroundImage: `url(${image})` }} />
                    </div>
                  ))}
                </Slider>
              </div>
              <h1 className="home-hero-title font-bold text-primary">
                Speed, accuracy, protection and longevity: GROUP V supplies Light Gauge Steel, Waterproofing, and Terrazzo systems: Delivered reliably to your project site.  
              </h1>
              <p className="home-hero-text">
                We simplify procurement by supplying dependable, performance-tested materials delivered on time and tailored to meet project requirements. 
                Where installation support is required, we collaborate with registered contractors while providing technical supervision and on-site support
                 to ensure correct system installation.
              </p>

              <div className="home-hero-actions">
                <button
                  className="btn btn-padded btn-primary home-hero-btn"
                  onClick={() => appContext.navTo({ item: "products" })}
                >
                  Solve Your Project Challenges
                </button>
                <button
                  className="btn btn-padded btn-light home-hero-btn"
                  onClick={() => appContext.navTo({item:'additional-services'})}
                >
                  Simplify Your Procurement
                </button>
              </div>
            </div>
          </article>

          <div className="home-hero-products-grid">
            {productCards.map((card, index) => (
              <article
                key={card.subItem}
                className={`home-hero-product-card h-100 ${card.featured ? "is-featured" : ""}`}
                style={{ backgroundImage: `url(${card.image})` }}
                onClick={() => appContext.navTo({ item: "products", subItem: card.subItem })}
                data-aos="fade-up"
                data-aos-duration="900"
                data-aos-delay={index * 110}
              >
                <div className="home-hero-product-overlay" />
                <div className="home-hero-product-content">
                  
                  <span className="home-hero-product-icon">{card.icon}</span>
                  <h3 className="home-hero-product-title font-bold">{card.title}</h3>
                  <p className="home-hero-product-text home-hero-product-text-secondary">
                    <span className="font-semi-bold"></span> {card.message}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .home-hero-product {
          padding: 26px 0 16px;
          background:
            linear-gradient(175deg, rgba(5, 15, 23, 0.58), rgba(7, 20, 30, 0.7)),
            url(${banner7}),
            radial-gradient(circle at 14% 8%, rgba(95, 163, 208, 0.2), transparent 42%),
            radial-gradient(circle at 86% 14%, rgba(97, 149, 193, 0.16), transparent 38%),
            linear-gradient(180deg, #eef6fc 0%, #f7fbff 52%, #ffffff 100%);
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        }

        .home-hero-grid {
          display: grid;
          padding-top:60px;
          grid-template-columns: 1.16fr 1fr;
          gap: 16px;
        }

        .home-hero-main-card {
          position: relative;
          align-self: start;
          border-radius: 20px;
          overflow: hidden;
          border: 1px solid rgba(150, 188, 215, 0.36);
          background:
            linear-gradient(165deg, rgba(8, 20, 31, 0.96), rgba(7, 18, 28, 0.96)),
            radial-gradient(circle at 16% 8%, rgba(112, 177, 221, 0.2), transparent 42%);
          box-shadow: 0 14px 32px rgba(8, 23, 36, 0.28);
        }

        .home-hero-main-overlay {
          position: absolute;
          inset: 0;
          background:
            linear-gradient(145deg, rgba(6, 17, 26, 0.54), rgba(5, 14, 22, 0.74)),
            radial-gradient(circle at 90% 10%, rgba(166, 214, 244, 0.12), transparent 34%);
            z-index: 0;
        }

        .home-hero-main-content {
          position: relative;
          z-index: 1;
          color: #f2f8ff;
          padding: 30px 28px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .home-hero-main-image {
          width: 100%;
          height: 70%;
          object-fit: cover;
          display: block;
        }

        .home-hero-main-media {
          height: 40vh;
          overflow: hidden;
        }

        .home-hero-main-slide {
          height: 40vh;
          background-size: cover;
          background-position: center;
        }

        .home-hero-main-media .slick-dots {
          bottom: 10px;
        }

        .home-hero-main-media .slick-dots li button:before {
          color: #ffffff;
          opacity: 0.72;
        }

        .home-hero-main-media .slick-dots li.slick-active button:before {
          opacity: 1;
        }

        .home-hero-eyebrow {
          margin: 0 0 10px;
          font-size: 32px;
          letter-spacing: 1.2px;
          color: #9fe4ff;
        }

        .home-hero-title {
          margin: 0 0 12px;
          font-size: 24px;
          line-height: 1.2;
          max-width: 98%;
        }

        .home-hero-text {
          margin: 0;
          font-size: 17px;
          line-height: 1.72;
          max-width: 90%;
          color: rgba(224, 240, 255, 0.9);
        }

        .home-hero-points {
          margin-top: 18px;
          display: grid;
          gap: 7px;
        }

        .home-hero-point {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          font-size: 17px;
          line-height: 1.45;
          color: #d8edff;
        }

        .home-hero-point-icon {
          min-width: 24px;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: rgba(156, 213, 247, 0.2);
          border: 1px solid rgba(180, 226, 252, 0.34);
          margin-top: 1px;
        }

        .home-hero-actions {
          margin-top: 18px;
          display: flex;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
        }

        .home-hero-btn {
          min-width: 158px;
        }

        .home-hero-products-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          grid-template-rows: auto auto;
          align-items: start;
          gap: 16px;
        }

        .home-hero-product-card {
          position: relative;
          align-self: start;
          border-radius: 18px;
          overflow: hidden;
          background-size: cover;
          background-position: center;
          border: 1px solid rgba(150, 188, 215, 0.32);
          box-shadow: 0 12px 28px rgba(12, 32, 50, 0.18);
          cursor: pointer;
          transition: transform 0.28s ease, box-shadow 0.28s ease, border-color 0.24s ease;
        }

        .home-hero-product-card.is-featured {
          grid-column: 1 / -1;
        }

        .home-hero-product-card:hover {
          transform: translateY(-2px);
          border-color: rgba(192, 223, 246, 0.58);
          box-shadow: 0 18px 32px rgba(11, 30, 47, 0.24);
        }

        .home-hero-product-overlay {
          position: absolute;
          inset: 0;
          background:
            linear-gradient(165deg, rgba(5, 13, 21, 0.76), rgba(4, 11, 18, 0.94) 52%, rgba(2, 8, 13, 0.99)),
            radial-gradient(circle at 85% 12%, rgba(167, 212, 240, 0.08), transparent 30%);
          z-index: 0;
        }

        
        .home-hero-product-card:hover .home-hero-product-overlay {
            background:var(--primaryColor);

        }

        .home-hero-product-content {
          position: relative;
          z-index: 1;
          color: #f5faff;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          padding: 18px;
        }

        .home-hero-product-media {
          width: 100%;
          overflow: hidden;
          border-radius: 10px;
          aspect-ratio: 16 / 9;
        }

        .home-hero-product-card.is-featured .home-hero-product-media {
          aspect-ratio: 21 / 9;
        }

        .home-hero-product-media-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        .home-hero-product-icon {
          width: 30px;
          height: 30px;
          border-radius: 9px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border: 1px solid rgba(187, 225, 250, 0.52);
          background: rgba(138, 191, 228, 0.18);
          margin-bottom: 5px;
        }

        .home-hero-product-title {
          margin: 0 0 8px;
          font-size: clamp(18px, 2vw, 26px);
          line-height: 1.2;
        }

        .home-hero-product-text {
          margin: 0;
          font-size: 17px;
          line-height: 1.55;
          color: rgba(223, 238, 249, 0.92);
        }

        .home-hero-product-text-secondary {
          margin-top: 8px;
        }

        .home-hero-product-link {
          margin-top: 12px;
          font-size: 17px;
          letter-spacing: 0.6px;
          color: #9fe4ff;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.2s ease;
        }

        .home-hero-product-link::after {
          content: ">";
          font-size: 17px;
          transform: translateX(0);
          transition: transform 0.2s ease;
        }

        .home-hero-product-card:hover .home-hero-product-link::after {
          transform: translateX(2px);
        }

        @media (max-width: 991px) {
          .home-hero-grid {
            grid-template-columns: 1fr;
            min-height: auto;
            padding-top:5px;
          }

          .home-hero-main-card {
            min-height: 380px;
          }

          .home-hero-main-media,
          .home-hero-main-slide {
            height: 30vh;
          }
        }

        @media (max-width: 767px) {
          .home-hero-product {
            padding: 14px 0 8px;
          }

          .home-hero-main-content {
            padding: 22px 16px;
          }

          .home-hero-title,
          .home-hero-text {
            max-width: 100%;
          }

          .home-hero-products-grid {
            grid-template-columns: 1fr;
          }

          .home-hero-product-card,
          .home-hero-product-card.is-featured {
            min-height: 190px;
            border-radius: 14px;
          }

          .home-hero-product-content {
            padding: 14px;
          }
        }
      `}</style>
    </section>
  );
}
